export class UserAuth {
  sessionId: string;
  uuid: string;
}

// Generated by https://quicktype.io

export interface CurrentUser {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  title: string;
  country: string;
  uuid: string;
  pictureUrl: string;
  userRoleName: string;
  email2: string;
  isNewMailVerified: boolean;
}

export class UserType {
  pictureUrl: string;
  id: number;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  password: string;
  active: boolean;
  uuid: string;
  online: boolean;
  isContact: boolean;
  isFavorite: boolean;
  hasNewMessages?: boolean;
  hasNote?: boolean;
  lookFor: string;
  offer: string;
  about: string;
  company: string;
  phone: string;
  country: string;
  countryCode: string;
  hasReceivedPendingRequest: boolean;
  lnPublicProfile: string;
  documentUuid: string;
  userRoleName: string;
  email2: string;
  isNewMailVerified: boolean;
}
// Generated by https://quicktype.io

export class GlobalUser {
  firstName: string;
  lastName: string;
  title: string;
  about: string;
  email: string;
  phone: string;
  company: string;
  country: string;
  countryCode: string;
  lnPublicProfile: string;
  documentUuid: string;
  email2: string;
  isNewMailVerified: boolean;
}

export class UpdateCurrentUser {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  title: string;
  country: string;
  uuid: string;
  pictureUrl: string;
  about: string;
  email2: string;
  isNewMailVerified: boolean;
}

export class UpdateUser {
  firstName: string;
  lastName: string;
  title: string;
  lookFor: string;
  offer: string;
  about: string;
  session: any;
  country: string;
  countryCode: string;
  company: string;
  email: string;
  email2: string;
  isNewMailVerified: boolean;
}

export class SocialUserRequest {
  provider: string;
  externalId: string;
  email: string;
  name: string;
  pictureUrl: string;
  accessToken?: string;
  firstName: string;
  lastName: string;
}

export class Interest {
  id: number;
  tag: string;
}

export class Country {
  code: string;
  name: string;
}

export class GroupContacts {
  letter: any;
  contacts: UserType[];
}

export class ContactRequest {
  friend: string;
  message: string;
}

export class ContactRequests {
  uuid: string;
  contacts: UserType[];
}

export class UserPosition {
  lat: number;
  lon: number;
}

// Generated by https://quicktype.io

// Generated by https://quicktype.io

export interface UserContacts {
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  elementsOnPage: number;
  totalElements: number;
  groupedData: GroupedData;
}

export interface GroupedData {
  additionalProp1: AdditionalProp[];
  additionalProp2: AdditionalProp[];
  additionalProp3: AdditionalProp[];
}

export interface AdditionalProp {
  session: Session;
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phone: string;
  company: string;
  country: string;
  countryCode: string;
  password: string;
  uuid: string;
  online: boolean;
  hasNewMessages: boolean;
  pickedMe: number[];
  contacts: number[];
  picks: number[];
  blocked: number[];
  blockedMe: number[];
  sentContactRequests: number[];
  receivedContactRequests: number[];
  rejectedContactRequests: number[];
  events: number[];
  isContact: boolean;
  isFavorite: boolean;
  hasSentPendingRequest: boolean;
  hasReceivedPendingRequest: boolean;
  guest: boolean;
  about: string;
  hasNote: boolean;
  picture: string[];
  firstLogin: boolean;
}

export interface Session {
  sessionId: string;
  uuid: string;
}



// WEBPACK FOOTER //
// ./src/models/user.model.ts